import * as Sentry from "@sentry/react";

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://2b9730ecff8f8fc62c01bcc172dc1049@o4508904578023424.ingest.us.sentry.io/4509138894913536",
    integrations: [Sentry.browserTracingIntegration()],
  
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:/ / yourserver.io / api / ],
  });
}